import { styled, css } from 'styled-components';

import { SpinnerProps } from '@src/components/atoms/spinner/types';

export const Svg = styled.svg<Pick<SpinnerProps, 'size'>>`
  ${({ size }) =>
    size === 'inline' &&
    css`
      vertical-align: sub;
      margin-left: 0.3em;
    `}
`;
